import React, { PureComponent } from 'react'
import { View, TouchableOpacity, Platform } from 'react-native'
import styled from 'styled-components/native'
import LineChart from '../../../Atoms/LineChart'
import TranslatedText from '../../../Atoms/TranslatedText'
import theme from '../../../../styles/theme'
import { Text } from '../../../Atoms/Typography'

const ContainerRow = styled(View)`
  flex: 1;
  flex-direction: row;
  padding: ${theme.gutterUnit * 2}px 0;
  background: ${theme.colours.white};
`

const Container = styled(View)`
  flex: 1;
`

const ChartY = styled(View)`
  flex: 0 1 auto;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 ${theme.gutterUnit}px;
  align-items: flex-end;
`

const XAxisLabel = styled(View)`
  minHeight: 30px;
  flex: 0;
  justify-content: center;
`

const YAxisLabel = styled(View)`
  top: 50%;
  height: 400px;
  margin-top: -200px;
  position: absolute;
  width: 30px;
`

const yAxisLabel = {
  width: 200,
  height: 200,
  textAlign: 'center',
  marginTop: 100,
  transform: [{ rotate: '270deg' }]
}

const YAxisBorder = styled(View)`
  position: absolute;
  right: -50px;
  top: 20px;
  bottom: 30px;
  width: 1px;
  background: #b1b1b1;
  z-index: 10;
`

const LegendContainer = styled(View)`
  padding: 0 ${theme.gutterUnit}px 0 ${theme.gutterUnit * 2}px;
  padding-left: 0;
  flex-direction: column;
  background: ${theme.colours.white};
  justify-content: center;
  display: flex;
  margin: -${theme.gutterUnit}px 0;
  margin-left: 20px;
`

const LegendItem = styled(TouchableOpacity)`
  background: ${props => props.background};
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  max-height: 40px;
  border-radius: 40px;
  flex-direction: row;
  margin-bottom: ${theme.gutterUnit / 2}px;
  padding: 0 ${theme.gutterUnit}px;
`
export default class ShareholderReturn extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isMeasurable: false,
      width: 0,
      height: 0,
      selectedTeam: this.props.currentTeam
    }
  }

  handleLayout = event => {
    if (this.state.isMeasurable) return // layout was already called
    const { width, height } = event.nativeEvent.layout
    this.setState({
      isMeasurable: true,
      width: width - theme.gutterUnit * 4,
      height: height - theme.gutterUnit * 4
    })
  }

  getSeries (data, selectedRound, selectedTeam) {
    const tickSpacing = 2.5
    let yMax = 0
    data.forEach(({ history }) => {
      history.forEach(({ value }) => {
        const valueCeil = Math.ceil(value / 100 / tickSpacing) * tickSpacing
        if (valueCeil > yMax) yMax = valueCeil
      })
    })
    let yMin = yMax
    data.forEach(({ history }) => {
      history.forEach(({ value }) => {
        const valueFloor = Math.floor(value / 100 / tickSpacing) * tickSpacing
        if (valueFloor < yMin) yMin = valueFloor
      })
    })
    const numberOfTicks = (yMax - yMin) / tickSpacing
    const baseSeries = {
      numberOfTicks,
      yMin,
      xMin: 0,
      yMax,
      xMax: selectedRound - 1,
      labelWidth: 60,
      contentInset: {
        left: 50,
        top: 20,
        bottom: 30,
        right: 20
      }
    }
    return {
      yMax,
      yMin,
      numberOfTicks,
      labelFormatter: (value) => parseFloat(value).toFixed(1) + '%',
      series: data.map(team => {
        const props = {
          ...baseSeries,
          name: team.name,
          team: team.team,
          stroke: team.team === selectedTeam ? theme.colours.chart.orange : theme.colours.chart.blue,
          data: team.history.map(({ value }) => (value / 100))
        }
        if (team.team === selectedTeam) {
          props.zIndex = 101
          props.showLabels = true
        }
        return props
      })
    }
  }

  getXAxis = ({ round }) => {
    const data = []
    for (let i = 0; i < (round); i++) data.push(0)
    return {
      data,
      contentInset: {
        left: 50,
        right: 20
      },
      svg: {
        fontFamily: Platform.select({ web: 'ubuntu-medium' }), // TODO fontFamily fix
        fontSize: 14,
        fill: '#888888'
      },
      style: {
        position: 'absolute',
        bottom: 0,
        height: 20,
        left: 0,
        width: this.state.width,
        zIndex: 200
      }
    }
  }

  getYAxis ({ numberOfTicks, yMax, yMin }) {
    return {
      yMin,
      yMax,
      numberOfTicks,
      labelFormatter: (value) => parseFloat(value).toFixed(1) + '%'
    }
  }

  onTeamButtomPress (selectedTeam) {
    return () => {
      this.setState({
        selectedTeam
      })
    }
  }

  render () {
    const { series, yMax, yMin, numberOfTicks, labelFormatter } = this.getSeries(this.props.data, this.props.selectedRound, this.state.selectedTeam)
    const yAxis = this.getYAxis({ yMax, yMin, numberOfTicks })
    const { type } = this.props
    return (
      <ContainerRow>
        <ChartY>
          <YAxisLabel>
            <TranslatedText size='s' semibold darkgrey overrides={yAxisLabel} value={`summaryScreen.metrics.${type}.unitLong`} default='Shareholder Return (%)' />
          </YAxisLabel>
          <XAxisLabel>
            <TranslatedText overrides={{ fontFamily: 'ubuntu-medium', fontSize: 14, fontWeight: 'normal', color: '#888888' }} value='general.year' default='Year' />
          </XAxisLabel>
          <YAxisBorder />
        </ChartY>
        <Container onLayout={this.handleLayout}>
          {this.state.isMeasurable &&
            <LineChart
              width={this.state.width}
              height={this.state.height}
              series={series}
              xAxis={this.getXAxis({ round: this.props.selectedRound })}
              yAxis={yAxis}
              labelFormatter={labelFormatter}
            />}
        </Container>
        <LegendContainer>
          {series.map((s, i) => {
            return (
              <LegendItem background={s.stroke} key={i} onPress={this.onTeamButtomPress(s.team)}>
                <Text size='xs' semibold>{s.name.toUpperCase()}</Text>
              </LegendItem>
            )
          })}
        </LegendContainer>
      </ContainerRow>
    )
  }
}
